import contract_controller from "./contract_controller";

export default class extends contract_controller {
  static targets = [ "numberDataDiv", "infoWalletNotice", "newWalletFields", "checkBoxWallet", "novemWalletOrdered" ]

  connect() {
    document.querySelectorAll(".second-step,.third-step,.fourth-step").forEach(e => e.classList.remove("d-none"));
    document.querySelectorAll(".bg-gradient-dark,.font-semibold").forEach(e => e.classList.add("d-none"));
    const contracts = ["NnnContract", "NnnPlusContract", "NxagPlusContract", "NptPlusContract", "NpdPlusContract"];
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const contract_type = urlParams.get("contract_type");
    if(contract_type === "NvmContract") {
      this.toggleWalletOptions();
    }
    if (contracts.includes(contract_type)) {
      this.toggleDepotField();
    }
    const step_buttons = document.querySelectorAll(".d-flex.justify-content-between:not(.align-items-center)");
    step_buttons.forEach(e => e.classList.add("d-none"));
    step_buttons.forEach(e => e.classList.remove("d-flex"));
    document.getElementById("email_confirmation").remove();
    document.querySelector("[for=\"email_confirmation\"]").remove();

    this.existingCustomerFieldsTarget.remove();
    this.customerModeDivTarget.remove();
    this.bankDataModeDivTarget.remove();

    this.contractTypeValue = $("input[name=contract\\[type\\]]:checked").val();
    this.updateContentOnContractType();

    // save denomination value
    const previousDenominationValue = $("[name='contract[denomination]']:checked").val();
    this.updateDenominationOptions();
    $(`[name='contract[denomination]'][value='${previousDenominationValue}']`).prop("checked", true);
    if(contract_type === "NeContract" || contract_type === "NjContract") {
      document.getElementsByClassName("form-check mb-35px")[5].classList.remove("mb-35px");
    }
    this.prefillProductsComb();
  }

  toggleDepotField() {
    const transferStatusField = document.querySelector("#contract_transfer_status");
    const depotInput = document.querySelector(".depot-input");
    if (!transferStatusField || !depotInput) return;

    if (transferStatusField.checked) {
      depotInput.classList.remove("d-none");
    } else {
      depotInput.classList.add("d-none");
    }
  }

  async prefillProductsComb() {
    const action = document.getElementById("contract_form").action.split("/");
    const contract_id = action[action.length - 1];
    let index = 0;
    const denominationQuantity = document.getElementsByName("contract[denomination_quantity][]");
    const denominationProducts = document.getElementsByName("contract[denomination_product][]");
    await fetch(`/admin/contracts/contract_denomination.json?contract_id_for_denomination=${contract_id}`).then(response => response.json()).then(r => {
      for (const [key, value] of Object.entries(r)) {
        index = this.findIndexForComb(key);
        denominationQuantity[index].value = value;
        denominationProducts[index].checked = true;
      }
    });
  }

  findIndexForComb(key) {
    const productNumbers = {
      "1g": 0,
      "5g": 1,
      "10g": 2,
      "20g": 3,
      "50g": 4,
      "2,5g": 5
    };

    return productNumbers[key];
  }

  editGoldProductsComb() {
    let editCheckSum = 0;
    const alert = document.getElementById("alertForGoldProducts");
    if (document.getElementById("contract_delivery_ex_20").checked) {
      editCheckSum = 20;
    } else if (document.getElementById("contract_delivery_ex_50").checked) {
      editCheckSum = 50;
    }
    let editSumCount = 0;
    let editFullSum = 0;
    const count_of_products = document.getElementsByName("contract[denomination_quantity][]");
    count_of_products.forEach((count, index) => {
      if (!isNaN(parseFloat(count.value)) && document.getElementsByName("contract[denomination_product][]")[index].checked) {
        editSumCount = parseInt(count.value);
        editFullSum += editSumCount * this.countOfProduct(document.getElementsByName("contract[denomination_product][]")[index]);
      }
    });
    if (editFullSum !== editCheckSum) {
      alert.classList.remove("d-none");
    } else {
      alert.classList.add("d-none");
    }
  }

  changeAppeal() {
    const observer = new MutationObserver(() => {
      const span = document.getElementById("select2-contract_customer_attributes_user_attributes_appeal-container");
      let firma = document.getElementById("company_name_firma_edit");
      if (!firma) {
        firma = document.getElementById("company_name_firma");
      }
      if (span.innerText === "Firma") {
        firma.classList.remove("d-none");
      } else {
        firma.classList.add("d-none");
      }
    });
    
    const targetNode = document.getElementById("select2-contract_customer_attributes_user_attributes_appeal-container");
    const config = { childList: true, subtree: true };
    
    observer.observe(targetNode, config);
  }

  onSubmit(e) {
    const alert = document.getElementById("alertForGoldProducts");
    if (this.invalidInputs !== 0) {
      e.preventDefault();
      this.scrollToInvalidInput();
    } else if (!alert.classList.contains("d-none")) {
      e.preventDefault();
      setTimeout(this.scrollToAlert, 1000);
    }
  }

  scrollToAlert() {
    const alert = document.getElementById("alertForGoldProducts");

    if (alert) {
      alert.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }

  get invalidInputs() {
    const invalidInputs = [];
    document.querySelectorAll("input.required, textarea.required, select.required button").forEach(function(item){
      if(item.offsetParent !== null && item.value.trim() === "" || item.type === "checkbox" && item.checked === false && item.nextSibling && item.nextSibling.offsetParent !== null) {
        item.classList.add("is-invalid");
        invalidInputs.push(item);
      } else {
        item.classList.remove("is-invalid");
      }
    });
    return invalidInputs.length;
  }

  updateContentOnContractType() {
    this.newCustomerFieldsTarget.classList.remove("d-none");
    switch (this.contractTypeValue) {
    case "NeContract": {
      this.childDataDivTarget.classList.add("d-none");
      this.moneyNeTarget.classList.remove("d-none");
      this.moneyNbTarget.classList.add("d-none");
      this.moneyNjTarget.classList.add("d-none");

      this.setupFeeTotalDivTarget.classList.remove("d-none");
      this.customAmountTarget.classList.replace("d-none", "d-flex");
      break;
    }
    case "NjContract": {
      this.childDataDivTarget.classList.remove("d-none");
      this.moneyNjTarget.classList.remove("d-none");
      this.moneyNeTarget.classList.add("d-none");
      this.moneyNbTarget.classList.add("d-none");

      this.setupFeeTotalDivTarget.classList.add("d-none");
      this.customAmountTarget.classList.replace("d-flex", "d-none");
      break;
    }
    case "NbContract": {
      this.childDataDivTarget.classList.add("d-none");
      this.moneyNbTarget.classList.remove("d-none");
      this.moneyNeTarget.classList.add("d-none");
      this.moneyNjTarget.classList.add("d-none");

      this.setupFeeTotalDivTarget.classList.remove("d-none");
      this.customAmountTarget.classList.replace("d-flex", "d-none");
      break;
    }
    default: {
      this.numberDataDivTarget.remove();
      this.thirdStepDivTarget.remove();
      this.fourthStepDivTarget.remove();
      break;
    }
    }

    if (this.contractTypeValue) {
      this.customMonthlyAmountRadioTarget.checked = true;
      this.setCustomMonthlyAmount();
      document.getElementById("agb_link").href = `${window.location.origin}/files/Vertrag_Novem_${this.contractTypeValue.substring(0, 2).toUpperCase()}_AGB.pdf`;
    }
  }
  
  toggleWalletAddressFields() {
    this.toggleWalletOptions();
  }

  toggleWalletOptions() {
    if (this.checkBoxWalletTargets[0].checked === true) {
      this.newWalletFieldsTarget.classList.remove("d-none");
      this.infoWalletNoticeTarget.classList.add("d-none");
    } else {
      this.newWalletFieldsTarget.classList.add("d-none");
      this.infoWalletNoticeTarget.classList.remove("d-none");
    }
  }

  updateNovemWalletOrdered(event) {
    const selected = event.target;
    this.novemWalletOrderedTarget.value = selected.dataset.novemWalletOrderedValue;
  }
  
  checkTokensQuantity() {
    const inputTokens = document.getElementById("contract_bundles_attributes_0_bundle_items_attributes_0_quantity");
    inputTokens.value = parseFloat(inputTokens.value).toFixed(4);
  }
  
  checkFreezePrice() {
    const inputFreezePrice = document.getElementById("contract_bundles_attributes_0_bundle_items_attributes_0_freeze_price");
    const formattedValue = parseFloat(inputFreezePrice.value.replace(",", ".")).toFixed(2).replace(".", ",");
    inputFreezePrice.value = formattedValue;
  }
  
  onTokenCountCalculateOption(e){
    const quantity = document.getElementById("contract_bundles_attributes_0_bundle_items_attributes_0_quantity");
    const freezePrice = document.getElementById("contract_bundles_attributes_0_bundle_items_attributes_0_freeze_price");
    if(e.target.checked){
      quantity.disabled = true;
      freezePrice.disabled = true;
    } else {
      quantity.disabled = false;
      freezePrice.disabled = false;
    }
  }
}
